module.exports = __webpack_public_path__ + "media/images/menu/canis_minor-cb5ab1c25a4825aca79ea4d5cf134007.jpg";